import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const airlineLogo = (code) =>
  `https://pics.avs.io/120/40/${code}.png`;

export const duffelLogo = (code) =>
  `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${(code || "").toUpperCase()}.svg`;

const RATES = { GBP: 1, USD: 1.27, EUR: 1.17 };
let CURRENCY = "GBP";
try { CURRENCY = localStorage.getItem("elia_cur") || "GBP"; } catch (e) {}

export const setCurrency = (c) => {
  CURRENCY = RATES[c] ? c : "GBP";
  try { localStorage.setItem("elia_cur", CURRENCY); } catch (e) {}
};
export const getCurrency = () => CURRENCY;

export const gbp = (n) => {
  const v = (Number(n) || 0) * RATES[CURRENCY];
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: CURRENCY, maximumFractionDigits: 0 }).format(v);
};
